import { selectWidgetsDataState } from 'widgets/store/selectors';
import State from 'store/State';

export const selectCorporateActionsDataState = (state: State) =>
    selectWidgetsDataState(state).corporateActions;

export const selectCorporateActionsRequestState = (
    state: State,
    requestKey: string
) => selectCorporateActionsDataState(state)[requestKey];
